import React, { useEffect, useState } from 'react'
import './single.scss'
import Sidebar from '../../../components/sidebar/Sidebar'
import Navbar from '../../../components/navbar/Navbar'
import { useParams } from 'react-router-dom'
import { collection, deleteDoc, doc, getDocs, onSnapshot, query, where } from 'firebase/firestore'
import { db } from '../../../firebase'
import image from '../../../assets/images/user.png'
import CloseIcon from '@mui/icons-material/Close';
import ConfirmBox from '../../../components/ConfirmBox'



const Single = () => {

  const {reviewId} = useParams()

  const [subscriberData, setSubscriberData] = useState("")

  const [reviewData, setReviewData] = useState([])

  const [isHovered, setIsHovered] = useState(false);

  const [hoveredId, setHoveredId] = useState(null);

  const [open, setOpen] = useState(false);

  const [deleteId, setDelete] = useState("");


  useEffect(() => {
      
      const reviewQuery = async() => {
  
        const reviewRef = (collection(db, "reviews"));
        const q = query(reviewRef, where("subId", "==", reviewId));
  
        const querySnapshot = await getDocs(q);
        
        let list = []

        querySnapshot.forEach((doc) => {

          list.push({id: doc.id, ...doc.data(), timeStamp: doc.data().timeStamp.toDate()})

          console.log(list)
  
          setReviewData(list)
          // console.log(riderData)
        });

  
      }
      
      reviewQuery()   
  },[])

  // const handledeletereview = async(id) => {

  //     await deleteDoc(doc(db, "reviews", id));   
      
  //     setReviewData(reviewData.filter((item) => item.id !== id))
  // }


  function openDelete(id) {

    setOpen(true);

    setDelete(id);

  }
  
    // console.log(data)


  
  const handleDelete = async() => {

    await deleteDoc(doc(db, "reviews", deleteId));
      
      setReviewData(reviewData.filter((item) => item.id !== deleteId))

      setOpen(false)

  }

    
  const getSubscriberInfo = () => {
  
      onSnapshot(doc(db, "subscribers", reviewId), (doc) => {
    
       console.log("Current data: ", doc.data());

       setSubscriberData({id: doc.id, ...doc.data(), date: doc.data().timeStamp.toDate().toLocaleString()})
    
      
     });
    
    
  }
  
  useEffect(()=>{

    getSubscriberInfo()
    

  }, [])


  console.log('review data: ', reviewData)
  
  return (
    <div className='single'>
      <Sidebar/>
      <div className='singleContainer'>
        <Navbar/>
        <div className="top">
          {/* <div className="left">
            <h2 className='title'>Outlet Photo</h2>
            <div className='item'>
                <img
                    src={subscriberData.files}
                    alt="avatar"
                    style={{width:200, height:200}}
                    // className="itemimg"

                />
              
            </div>
          </div> */}


           <div className="left">
            {/* <div className="editbutton">Edit</div> */}
            <h2 className='title'>Outlet Info</h2>
            <div className='item'>
                <div className="details">
                  {/* <h3 className='itemTitle'>Outlet </h3> */}
                  <div className='detailItem'>
                    <span className='itemKey'>Outlet:</span>
                    <span className='itemValue'>{subscriberData.outletname} {subscriberData.outlet}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Region:</span>
                    <span className='itemValue'>{subscriberData.region}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Area:</span>
                    <span className='itemValue'>{subscriberData.area}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Address:</span>
                    <span className='iitemValue'>{subscriberData.address}</span>
                  </div>
                </div>
            </div>
          </div>
       
        </div>
        <div className='bottom'>

          <h2 style={{fontSize:18, fontWeight:'bold', color:'#999', marginTop:20, marginBottom:50}}>Customers Review</h2>

           <ul>

             {

                reviewData.map(item => {

                  return(

                    <li
                      key={item.id}
                      onMouseEnter={() => setHoveredId(item.id)}
                      onMouseLeave={() => setHoveredId(null)}
                      style={{
                        padding: '12px',
                        cursor: 'pointer',
                        marginBottom: 20,
                        backgroundColor: hoveredId === item.id ? '#e0e0e0' : 'transparent',
                        borderRadius: 8, flexDirection:'row', display:'flex', alignItems:'center', gap:20, position:'relative', boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)'
                      }}
                    >

                      <img

                        src={image}
                        alt="avatar"
                        style={{width:80, height:80, borderRadius:'50%'}}

                      />

                      <div style={{display:'flex', flexDirection:'column', marginLeft:20, gap:10}}>
                        <p style={{color:'#666', fontSize:16}}>{item.commentor}</p>
                        <p style={{color:'#ccc', fontSize:14}}>{item.today}</p>
                        <p style={{fontSize:16, color:'#999'}}>{item.review}</p>
                      </div>

                        <div onClick={() => openDelete(item.id)} style={{position:'absolute', top:10, right:10, cursor:'pointer'}}>
                          <CloseIcon style={{color:'red'}}/>
                        </div>
                      
                    </li>
                            
                  )

                })
                
              }

           </ul>

         

        </div>
      
      </div>

      <ConfirmBox
        open={open}
        closeDialog={() => setOpen(false)}
        // title={deleteData?.name}
        deleteFunction={handleDelete}
      />

    </div>
  )
}

export default Single

